import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectFabricationDataForPrices } from 'us_quickturn_prototype_pcb/pcb_fabrication/slice/selectors';
import { priceSelected } from 'us_quickturn_prototype_pcb/pcb_fabrication/slice/fabricationSlice';

import PriceMatrix from 'shared/components/price/PriceMatrix';
import PcbInstructions from 'us_quickturn_prototype_pcb/pcb_fabrication/components/PcbInstructions';
import ContinueButton from 'us_quickturn_prototype_pcb/pcb_fabrication/components/ContinueButton';
import QuoteActionBar from 'us_quickturn_prototype_pcb/pcb_fabrication/components/QuoteActionBar';
import Terms from 'us_quickturn_prototype_pcb/pcb_fabrication/components/Terms';

const Price = () => {
  const dispatch = useDispatch();
  const { quote, parametersChanged, parameters, quoteStep } = useSelector(
    selectFabricationDataForPrices,
  );

  const onPriceSelect = (data) => {
    dispatch(priceSelected(data));
  };

  const lineItem = quote?.line_items[0];

  return (
    <div className="container-fluid quote-result">
      <div className="row mb-3">
        <div className="col-12 d-flex flex-row justify-content-between align-items-center">
          <PcbInstructions />
          <ContinueButton />
        </div>
      </div>
      <div className="row">
        <div className="col-12 px-0">
          <PriceMatrix
            tableStripe
            lineItem={lineItem}
            parametersChanged={parametersChanged}
            onPriceSelect={onPriceSelect}
            parameters={parameters}
            quoteStep={quoteStep}
          />
        </div>
      </div>
      <Terms />
      <div className="row">
        <div className="col-md-12">
          <QuoteActionBar />
        </div>
      </div>
    </div>
  );
};

export default Price;
